import React, { useState } from 'react';
import { Badge, Button, Card, Col, Form, ListGroup, Modal, Row } from 'react-bootstrap';

const ItemCard = ({ item, onAddToCart }) => {


    const [showModal, setShowModal] = useState(false);
    const [itemData, setItemData] = useState(item);

    const formatter = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });


    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleCloseModalCorf = () => {
        setShowModal(false);
        onAddToCart(itemData);
    };


    const handleConfirmAddItem = () => {
        setShowModal(true);
    };


    const handleChangeItems = (e) => {
        const { name, value } = e.target;
        setItemData({
            ...itemData,
            [name]: value
        });
    };

    return (

        <>
            <Card style={{ width: '18rem', margin: '1rem', position: 'relative' }}>
                {/* Etiqueta de promoción */}
                {item.promotion.id_promotion && (
                    <Badge
                        bg="warning"
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            padding: '10px',
                            fontSize: '0.9rem',
                        }}
                    >
                        Descuento: {parseInt(item.promotion.discount)}%
                    </Badge>
                )}

                {/* Imagen del producto */}

                <div className="text-center">
                    <Card.Img
                        variant="top"
                        style={{
                            maxHeight: '200px',
                            alignContent: 'center',
                            maxWidth: '180px',
                            padding: '1px',
                            margin: '10px 0 0 0 '
                        }}
                        src={item.url || 'https://via.placeholder.com/150'}
                        alt={item.description}
                    />
                </div>

                {/* Detalles del producto */}
                <Card.Body>
                    <div style={
                        { height: "50px",
                            marginBottom:"10px"
                         }
                    }>
                        <Card.Title>{item.description} {
                        item.weight.weight_name != "N/A" ? item.weight.weight_name : "" 
                        }</Card.Title>
                    </div>
                    <div style={
                        { height: "50px" }
                    }>
                        <Card.Subtitle
                        style={{
                            color:"silver"
                        }}
                        >{item.product.name}</Card.Subtitle>
                    </div>
                    <ListGroup variant="flush" >

                        {item.size.id_size && (
                            <ListGroup.Item>
                                <strong>Talla: </strong> {item.size.size_name}
                            </ListGroup.Item>
                        )}


                        {item.color.id_color && (
                            <ListGroup.Item>
                                <strong>Color: </strong> <Badge bg="info">{item.color.color_name}</Badge>
                            </ListGroup.Item>
                        )}
                        <ListGroup.Item >
                            <strong>Precio: </strong> {formatter.format(item.price)}
                        </ListGroup.Item>
                    </ListGroup>
                    {/* Botón para acción */}
                    <Button variant="info"
                        style={{ marginTop: '10px', width: '100%', color: "white" }}
                        onClick={handleConfirmAddItem}>
                        Agregar
                    </Button>
                </Card.Body>
            </Card >

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar el precio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="formItemPrice">
                        <Form.Label><strong>Precio</strong></Form.Label>
                        <Form.Control
                            type="number"
                            name="price"
                            onChange={handleChangeItems}
                            placeholder="Digite el precio"
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleCloseModalCorf}>
                        Confirmar Compra
                    </Button>
                </Modal.Footer>
            </Modal>


        </>

    );
}

export default ItemCard;